import { t } from "i18next";
import { useTabsStore } from "../../../stores/TabsStore";
import { Button } from "../../../ui/Button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../../../ui/DropdownMenu/DropdownMenu";
import ReportSaveForm from "./ReportSaveForm";

function ReportViewButton() {
    const tabStore = useTabsStore()
    let tab = tabStore.tabs.find(t => t.id === tabStore.activeTabId)!

    return (
      <div className="flex flex-none w-full h-full gap-2 items-center">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size={"datepicker"} className={`${tab.view === "report" ? "bg-primary text-white" : ""}`}>{t('reports')}</Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-56" align="start">
            <DropdownMenuLabel>{t('summary')}</DropdownMenuLabel>
            <DropdownMenuItem 
              className={`${tab.reportOptions.type === "summary" ? "text-primary" : ""}`}
              onClick={() => tabStore.changeTabView(tab.id, "report", "summary", tab.defaultValues?.persons?.map(e => String(e.value))!)}
            >
              {t('summary_report_by_persons')}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>{t('staff')}</DropdownMenuLabel>
            {tab.defaultValues?.persons?.map(p => (
              <DropdownMenuItem 
                key={p.value}
                className={`${tab.reportOptions.type === "item" && tab.reportOptions.items.includes(p.value) ? "text-primary" : ""}`}
                onClick={() => tabStore.changeTabView(tab.id, "report", "item", [p.value])}
              >
                {p.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
        <Button variant={"outline"} size={"datepicker"} className={`${tab.view === "table" ? "bg-primary text-white" : ""}`} onClick={() => tabStore.changeTabView(tab.id, "table", null, [])}>
            {t('data')}
        </Button>
        <Button variant={"outline"} size="datepicker" className="gap-2" onClick={() => tabStore.changeTabView(tab.id, "settings", null, [])}>
            {t('settings')}
        </Button>
        <ReportSaveForm tab={tab} />
      </div>
    )
}

export { ReportViewButton };
